import {
  Alert,
  NewUser,
  OrganizationForm,
  RoundedTab,
  RoundedTabGroup,
  SearchOrgUser,
  InvoiceList,
  InvoiceDialog,
} from "@mikros/shared-ui";
import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";
import ApiServices from "../../service/apiService";
import { OrganizationDetails } from "@mikros/library/src/model";
import { FormattedMessage, useIntl } from "react-intl";
import { Dialog } from "@progress/kendo-react-dialogs";
import { UserDetails } from "@mikros/library";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { useNavigate } from "react-router-dom";
import S3Service from "../../service/s3Service";

export function Organization() {
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const [showNewUser, setShowNewUser] = useState(false);
  const [showSearchUser, setShowSearchUser] = useState(true);
  const [showAdminuserTab, setAdminuserTab] = React.useState<boolean>(true);
  const [organizationData, setOrganizationData] = useState<any>();
  const [formDialog, setformDialog] = React.useState<boolean>(false);
  const [adminUserData, setadminUserData] = useState<any>();
  const [formType, setFormType] = useState<boolean>(false);
  const [userId, setUserId] = useState<any>();
  const [saveDialog, setSaveDialog] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const accountInstance = Account.getInstance();
  const [gridData, setGridData] = useState({} as UserDetails);
  const [warningDialog, setWarningDialog] = useState<boolean>(false);
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [destinationFilePath, setDestinationFilePath] = useState<string>("");
  const [invoicesList, setInvoicesList] = useState<any[]>([]);
  const [loadingInvoices, setLoadingInvoices] = useState<boolean>(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const [invoiceDialogOpen, setInvoiceDialogOpen] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<string>("Org");

  console.log("checking in organization for demo");
  console.log("organization data print", organizationData);
  console.log("form dialog", formDialog);
  console.log("print admin user data", adminUserData);
  console.log("save dialog state", saveDialog);
  console.log("admin user tab", showAdminuserTab);
  console.log("grid data in organization", gridData);
  console.log("phone number in organization", phoneNumber);
  console.log("show new user state", showNewUser);
  var flag = 0;

  const removeFileFromS3 = async (
    accntId: string,
    folder: string,
    newFileName: string
  ) => {
    console.log(
      "print the accnt id, folder, new file name  in remove file",
      accntId,
      folder,
      newFileName
    );
    let s3 = S3Service.getInstance();
    await s3
      .removeFile(`acct-${accntId}/${folder}/${newFileName}`, "Cust-Info")
      .then(() => console.log("Old file deleted success"));
  };

  const [logoDestinationFilePath, setLogoDestinationFilePath] =
    useState<string>("");
  const [signature1DestinationFilePath, setSignature1DestinationFilePath] =
    useState<string>("");
  const [signature2DestinationFilePath, setSignature2DestinationFilePath] =
    useState<string>("");

  const uploadFileToS3 = (
    e: any,
    accntId: string,
    folder: string,
    existingFileName: string
  ) =>
    new Promise<object>((resolve, reject) => {
      let destFilePath = `Cust-Info/acct-${accntId}/${folder}/${e?.target?.name}`;
      console.log("print event received", e);
      const reader = new FileReader();
      let s3 = S3Service.getInstance();
      const newFileName = e?.target?.name;

      const filePathToPass = destFilePath.replace(/^Cust-Info\//, "");

      reader.readAsDataURL(e?.target);
      reader.onload = async () => {
        let file = s3.convertToFile(
          reader.result,
          e?.target?.type,
          e?.target?.name
        );
        console.log("File formed", file);
        console.log("existing file name print", existingFileName);
        console.log("new file name print", newFileName);
        console.log("destination file path", destFilePath);

        console.log("Target type",e?.target?.type)
        console.log("File print",file)
        console.log("Destination file path",destFilePath)


        console.log("File path to pass",filePathToPass)
        console.log("File content to pass",file)

        // Set the destination file path based on the folder type
        if (folder === "logo") {
          setLogoDestinationFilePath(destFilePath);
        } else if (folder === "signature1") {
          setSignature1DestinationFilePath(destFilePath);
        } else if (folder === "signature2") {
          setSignature2DestinationFilePath(destFilePath);
        }

        if (existingFileName && existingFileName !== newFileName) {
          console.log("Deleting old file:", existingFileName);
          await s3
            .removeFile(
              `acct-${accntId}/${folder}/${existingFileName}`,
              "Cust-Info"
            )
            .then(() => console.log("Old file deleted success"))
            .catch((error) => console.error("deleting old file error", error));
        }

        await s3
          // .writeFileInFolder(destFilePath, file, "Cust-Info", e?.target?.type)
          .writeFileInFolder(filePathToPass, file,"Cust-Info",e?.target?.type)
          .then(async (res) => {
            console.log("Response is", res);
          });

        return destFilePath;
      };
    });

  const toggleUploadErrorDialog = () => {
    setUploadError(!uploadError);
  };

  // const readerUpload = (e: any) =>
  //   new Promise<object>((resolve, reject) => {
  //     const reader = new FileReader();
  //     let s3 = S3Service.getInstance();
  //     let element = e.fileName;
  //     console.log("print file name", element);

  //     reader.readAsDataURL(element);
  //     reader.onload = async () => {
  //       let file = s3.convertToFile(reader.result, element.type, element.name);
  //       console.log("file reader", file);

  //       await s3
  //         .writeFileInFolder(e.filePath, file, "Mikros-Cards", e.fileName.type)
  //         .then(async (res) => {})
  //         .catch((e) => {
  //           // toast.error("Something went wrong");
  //           toggleUploadErrorDialog();
  //           reject(e);
  //         });
  //     };
  //   });

  // const apigetPresignedUrl = async (courseId: any, filePath: string) => {
  //   console.log("inside create course api ");
  //   console.log("inside api,courseId", courseId);
  //   console.log("inside api,filePath ", filePath);
  //   let body = {
  //     filePath: filePath,
  //   };
  //   let api = ApiServices.getInstance();

  //   let apiCall = {} as any;
  //   if (accountInstance.accntId) {
  //     apiCall = await api.makeRequest(
  //       `${accountInstance.accntId}/course/${courseId}`,
  //       "POST",
  //       body
  //     );
  //   }
  //   if (apiCall) {
  //     console.log("api call", apiCall);
  //     return apiCall;
  //   }
  // };

  // const handleUploadLogorUrl = async (e: any) => {
  //   let url;
  //   url = await readerUpload(e);
  //   console.log("this is the url in upload logo url", url);
  //   return url;
  // };

  const toggleWarningDialog = () => {
    setWarningDialog(!warningDialog);
  };
  const toggleformDialog = () => {
    setformDialog(!formDialog);
  };
  // const toggleSaveDialog = () => {
  //   setSaveDialog(!saveDialog);
  // };
  const intl = useIntl();

  console.log("print form type", formType);
  // const auditValues: { [key: string]: boolean } = {
  //   Enabled: true,
  //   Disabled: false,
  // };
  // const certificationValues: { [key: string]: boolean } = {
  //   Enabled: true,
  //   Disabled: false,
  // };

  useEffect(() => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/organization`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }

          if (data?.errorMessage === "PERMISSION_DENIED") {
            console.log("inside data error");
            toggleWarningDialog();
          } else if (data) {
            data.whatAccessToken = data?.distbAcc?.whatsApp?.accTkn;
            data.whatsapp = data?.distbAcc?.whatsApp?.enabled;
            data.teams = data.distbAcc.teams.enabled;
            data.teamAccessToken = data.distbAcc.teams.accTkn;
            data.slack = data.distbAcc.slack.enabled;
            data.slackAccessToken = data.distbAcc.slack.accTkn;
            data.emailCheck = data.distbAcc.email.enabled;
            data.emailAccessToken = data.distbAcc.email.accTkn;

            // let a = new Date(parseInt(data?.validUpTo)).toString();

            let a = new Date(data?.validUpTo).toString();
            console.log("print a date value .adfaeifarjewa", a);
            const invalidDateMessage = intl.formatMessage({
              id: "organization.invalidDate",
            });
            if (a === invalidDateMessage) {
              data.validUpTo = "";
            }
            data.validUpTo = a || "";

            console.log("organization form response", data);
            setOrganizationData(data);
          }
        });
    }

    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/customersadmin`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("admin data", data);
          console.log("print data role in get", data?.role);
          setadminUserData(data);
        });
    }
  }, [accountInstance.accntId, showAdminuserTab]);

  const handleGridItemClick = (data: any) => {
    setUserId(data.dataItem.userId);
    setGridData(data);
    setFormType(true);
    setAdminuserTab(false);
    console.log("rec data in parent", data);
    flag = 1;
  };

  function getOrganizationFormData(data: any) {
    console.log("data ", data);
    let body: OrganizationDetails & {
      invoiceConfig?: { type?: string; month?: number; year?: number };
    } = {
      dateCreated: organizationData?.dateCreated,
      organizationName: data?.orgName,
      address: {
        add1: data.addrLine1,
        add2: data.addrLine2,
        city: data.city,
        state: data.state,
        country: data.country,
        zipcode: data.zipCode,
      },
      email: data.email,
      // phNo: data.mobile,
      phNo: data.userProfile.phNo,
      legalName: data.legalName,
      distbAcc: {
        whatsApp: {
          enabled: data.whatsapp ? true : false,
          accTkn: data.whatAccessToken ? data.whatAccessToken : "",
        },
        teams: {
          enabled: data.teams ? true : false,
          accTkn: data.teamAccessToken ? data.teamAccessToken : "",
          azureId: "",
        },
        slack: {
          enabled: data.slack ? true : false,
          accTkn: data.slackAccessToken ? data.slackAccessToken : "",
        },
        email: {
          enabled: data.emailCheck ? true : false,
          accTkn: data.emailAccessToken ? data.emailAccessToken : "",
        },
      },

      validUpTo:
        data.validUpTo ===
        intl.formatMessage({ id: "organization.invalidDate" })
          ? ""
          : data.validUpTo,
      status: data.status,
      // tax: data.tax,
      aiModel: data.aiModel,
      analytics: data?.analytics ? true : false,
      featureAccess: {
        audit: data?.featureAccess?.audit ? true : false,
        certification: data?.featureAccess?.certification ? true : false,
        certification_details: {
          sign1: {
            signerName:
              data?.featureAccess?.certification_details?.sign1?.signerName,
            signerRole:
              data?.featureAccess?.certification_details?.sign1?.signerRole,
            signUrl:
              signature1DestinationFilePath ||
              data?.featureAccess?.certification_details?.sign1?.signUrl,
          },
          sign2: {
            signerName:
              data?.featureAccess?.certification_details?.sign2?.signerName,
            signerRole:
              data?.featureAccess?.certification_details?.sign2?.signerRole,
            signUrl:
              signature2DestinationFilePath ||
              data?.featureAccess?.certification_details?.sign2?.signUrl,
          },
        },
      },
      // logo: data.logo || "",
      logo: logoDestinationFilePath || data.logo,
      accntId: data.accntId,
      createdAt: 0,
      lowerEmail: data.lowerEmail,
      lowerLegalName: data.lowerLegalName,
      lowerOrgName: data.lowerOrgName,
      // orgId: data.orgId,
      updatedAt: 0,
      invoiceConfig: {
        type: data?.invoiceConfig?.type || "",
        month: data?.invoiceConfig?.month,
        year: data?.invoiceConfig?.year,
      },
    };
    let api = ApiServices.getInstance();
    api
      .makeRequest(`${accountInstance.accntId}/organization`, "POST", body)
      .then(async (res) => {
        if (res && res.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        console.log("res in organization", res);
        toggleformDialog();
      });
  }

  const handleGenerateInvoice = (invoicePayload: {
    type: string;
    year: number;
    month: number;
    fromTime: number;
    tillTime: number;
  }) => {
    if (!invoicePayload || !accountInstance.accntId) return;
    const body = {
      accntId: accountInstance.accntId,
      option: invoicePayload.type,
      fromTime: invoicePayload.fromTime,
      tillTime: invoicePayload.tillTime,
    };
    let api = ApiServices.getInstance();
    api
      .makeRequest(
        `${accountInstance.accntId}/organization/invoice`,
        "POST",
        body
      )
      .then(async (res) => {
        console.log("invoice generation response", res);
        if (res && res.errorMessage) {
          // Show error in UI using the same pattern as other errors
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        if (res) {
          // Invoice generated successfully - refresh the invoice list
          // User can click on the new invoice in the list to see details
          fetchInvoices();
        }
      })
      .catch(async (err) => {
        console.error("invoice generation error", err);
        setErrorFlag(true);
        await errorInstance.updateErrorCode(err?.message || "INVOICE_GENERATION_FAILED");
      });
  };

  const formatDate = (dateValue?: any) => {
    if (!dateValue) return "-";
    // If already formatted string
    if (typeof dateValue === "string" && /[a-zA-Z]/.test(dateValue)) {
      return dateValue;
    }
    // Handle epoch timestamp or numeric string
    let timestamp = dateValue;
    if (typeof dateValue === "string") {
      // Try parsing as ISO date first
      const isoDate = new Date(dateValue);
      if (!isNaN(isoDate.getTime())) {
        const day = isoDate.getDate().toString().padStart(2, "0");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[isoDate.getMonth()];
        const year = isoDate.getFullYear();
        return `${day}-${month}-${year}`;
      }
      timestamp = Number(dateValue);
    }
    if (typeof timestamp === "number" && !isNaN(timestamp)) {
      const ms = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
      const date = new Date(ms);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, "0");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    }
    return String(dateValue);
  };

  const formatCurrency = (value?: number) => {
    if (value === undefined || value === null || isNaN(Number(value))) {
      return "-";
    }
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const renderValue = (val: any) => {
    if (val === undefined || val === null) return "-";
    if (typeof val === "number" || typeof val === "string" || typeof val === "boolean") {
      return String(val);
    }
    if (typeof val === "object") {
      if ("count" in val && typeof (val as any).count !== "object") {
        return String((val as any).count);
      }
      if ("value" in val && typeof (val as any).value !== "object") {
        return String((val as any).value);
      }
      if ("name" in val && typeof (val as any).name !== "object") {
        return String((val as any).name);
      }
      try {
        return JSON.stringify(val);
      } catch {
        return "-";
      }
    }
    return "-";
  };
  function submitAdminUser(data: any) {
    console.log("print submit admin user data", data);
    if (formType) {
      data.userId = userId;

      if (data.role === intl.formatMessage({ id: "organization.superAdmin" })) {
        data.role = "tnt_superAdmin";
      } else if (
        data.role === intl.formatMessage({ id: "organization.admin" })
      ) {
        data.role = "tnt_admin";
      } else if (
        data.role === intl.formatMessage({ id: "organization.reviewer" })
      ) {
        data.role = "tnt_reviewer";
      } else if (
        data.role === intl.formatMessage({ id: "organization.courseScheduler" })
      ) {
        data.role = "tnt_courseScheduler";
      } else if (
        data.role === intl.formatMessage({ id: "organization.contentCreator" })
      ) {
        data.role = "tnt_contentCreator";
      } else if (
        data.role === intl.formatMessage({ id: "organization.auditor" })
      ) {
        data.role = "tnt_auditor";
      }

      let api = ApiServices.getInstance();
      api
        .makeRequest(`${accountInstance.accntId}/customersadmin`, "POST", data)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("res in form type", res);
          setSaveDialog(!saveDialog);
        });
    } else {
      console.log("submit admin user in edit");
      data.userId = "";
      let api = ApiServices.getInstance();
      api
        .makeRequest(`${accountInstance.accntId}/customersadmin`, "POST", data)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("post response", res);
          setSaveDialog(!saveDialog);
        });
    }
    return data;
  }

  const fetchInvoices = () => {
    if (!accountInstance.accntId) return;
    setLoadingInvoices(true);
    let api = ApiServices.getInstance();
    api
      .makeRequest(`${accountInstance.accntId}/organization/invoice`, "GET")
      .then(async (res) => {
        setLoadingInvoices(false);
        if (res && res.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        // API response: { success, count, invoices }
        if (res?.invoices && Array.isArray(res.invoices)) {
          setInvoicesList(res.invoices);
        } else if (Array.isArray(res)) {
          setInvoicesList(res);
        } else {
          setInvoicesList([]);
        }
      })
      .catch((err) => {
        setLoadingInvoices(false);
        console.error("Error fetching invoices", err);
      });
  };

  const handleInvoiceItemClick = (invoice: any) => {
    setSelectedInvoice(invoice);
    setInvoiceDialogOpen(true);
  };

  function resetTabs(tabName: string) {
    setShowNewUser(false);
    setShowSearchUser(true);
    setAdminuserTab(true);
    setFormType(true);
    if (tabName === "Invoices") {
      fetchInvoices();
    }
  }

  const handleNewUserClick = () => {
    setFormType(false);
    setShowNewUser(true);
    setShowSearchUser(false);
    setAdminuserTab(false);
  };

  return (
    <div className="flex">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"/errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              }
            }}
          />
        </Dialog>
      )}
      {uploadError && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "course.createCourse.readerUploadError",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleUploadErrorDialog();
            }}
          />
        </Dialog>
      )}
      {formDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "organization.updateSuccess",
            })}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"/successShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleformDialog();
              navigate("/home");
            }}
          />
        </Dialog>
      )}



      {warningDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            // description= "You are not authorized to perform this action."
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"/errorShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleWarningDialog();
            }}
          />
        </Dialog>
      )}

      <RoundedTabGroup
        className="w-full"
        defaultTabName="Org"
        selectedTab={currentTab}
        onTabChange={setCurrentTab}
        onClick={resetTabs}
      >
        <RoundedTab
          name="Org"
          title={intl.formatMessage({ id: "organization.organizationTab" })}
        >
          <OrganizationForm
            getOrganizationFormData={getOrganizationFormData}
            customerData={organizationData}
            formType={"EDIT"}
            adminUserState={setAdminuserTab}
            uploadFileToS3={uploadFileToS3}
            removeFileFromS3={removeFileFromS3}
            pageType={"tenant"}
            onGenerateInvoice={handleGenerateInvoice}
          />
        </RoundedTab>

        {
          <RoundedTab
            name="AdminUser"
            // title="Admin Users"
            title={intl.formatMessage({ id: "organization.adminUserTab" })}
          >
            <div className="w-full flex justify-end items-center mt-[-2.25rem] right-12 top-20">
              {showAdminuserTab && (
                <Button
                  className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                            hover:text-black focus:outline-none px-4 py-2"
                  onClick={handleNewUserClick}
                >
                  {/* New User+ */}
                  <FormattedMessage id="organization.newUserButton"></FormattedMessage>
                </Button>
              )}
            </div>
            <div className="mb-10"></div>
            {showAdminuserTab && (
              <div className="pb-[10%]">
                <SearchOrgUser
                  searchUserState={setShowSearchUser}
                  newUserState={setShowNewUser}
                  dataGridItemFunction={handleGridItemClick}
                  adminUserData={adminUserData}
                  adminUserState={setAdminuserTab}
                  formTypeFunction={setFormType}
                  phoneNumber={phoneNumber}
                />
              </div>
            )}

            {showNewUser && (
              <NewUser
                submitAdminUser={submitAdminUser}
                dataGridItem={gridData}
                formType={formType ? "EDIT" : "NEW"}
                formTypeFunction={setFormType}
                newUserState={setShowNewUser}
                adminUserState={setAdminuserTab}
                pageType={"tenant"}
                saveDialogFunction={setSaveDialog}
                saveDialog={saveDialog}
                phNoFunction={setPhoneNumber}
                phNo={phoneNumber}
                accntId={accountInstance.accntId}
              />
            )}
          </RoundedTab>
        }

        <RoundedTab
          name="Invoices"
          title={intl.formatMessage({ id: "organization.invoicesTab" })}
        >
          <div className="pb-[10%] pt-4">
            <InvoiceList
              invoices={invoicesList}
              loading={loadingInvoices}
              onInvoiceClick={(invoice) => {
                setSelectedInvoice(invoice);
                setInvoiceDialogOpen(true);
              }}
              onRefresh={fetchInvoices}
              organizationName={organizationData?.organizationName}
              hideInvoiceType={true}
            />
          </div>
        </RoundedTab>
      </RoundedTabGroup>

      <InvoiceDialog
        open={invoiceDialogOpen}
        onClose={() => setInvoiceDialogOpen(false)}
        invoice={selectedInvoice}
        organizationName={organizationData?.organizationName}
        organizationEmail={organizationData?.email}
        organizationPhone={organizationData?.phNo}
      />
    </div>
  );
}
